export default __webpack_public_path__ + "static/media/033-truck.5618bbe9.png";